import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { ClassifySettingComponent } from 'src/app/back-office/components/edit-project/project-editing/classify-setting/classify-setting.component';

@Component({
  selector: 'app-vcl-content',
  templateUrl: './vcl-content.component.html',
  styleUrls: ['./vcl-content.component.scss', '../../../components/table/table.component.scss']
})
export class VcContentComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() filterData:any = [];
  platformInfos:any = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}
  pageId = 'vcl-content'
  modes:{ [x:string]: string|number }[] = [{id:1, value: 'Raw'}, {id: 2, value: 'Edited'},{id: 3, value: 'Classified'}, {id: 4, value: 'Edited & Classified'}, {id: 5, value: 'Archived'}];
  devices: any[] = [];

  ngOnInit() {
    this.loadData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterData'] && !changes['filterData'].firstChange) {
      this.loadData();
    }
  }
  
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  contentOption(rowInfos:any){
    let duplicateRows = this.dataSource.filter((row: any)=> rowInfos['id_content_duplicate'].includes(row.id_content))
    const dialogRef = this.dialog.open(ClassifySettingComponent, {
      width: '70%',
      position: {top: '30px' },
      data: {is_multiple: false, selected_rows: [rowInfos], duplicate_rows: duplicateRows, user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: []}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
      if(response.status) this.setUpdatedContent(response.contents, this.platformInfos.key);
    });
  }
  contentsSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      const dialogRef = this.dialog.open(ClassifySettingComponent, {
        width: '70%',
        position: {top: '30px' },
        data: {is_multiple: true, selected_rows: selectedRows, duplicate_rows: [], user_infos: this.userInfos, platform_infos: this.platformInfos, project_infos: []}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
        if(response.status) this.setUpdatedContent(response.contents, this.platformInfos.key);
      });
    }else this.helper.showToast('Select contents first...');
  }

  loadData(){
    if(this.filterData && Object.keys(this.filterData).length > 0){
      this.inProgress.emit(true);
      this.filterData.offset = this.navIndex * this.filterData.limit;
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/web/content/load', this.filterData, this.userInfos['access_token']).subscribe((response)=>{
        this.dataSource = response.map((row:any) => {
          row['year_name'] = [4, 5, 7].includes(row['id_section'])  ? ((row['id_content_learning'] ?? '')  + ' ' + (row['content_name'] ?? '')) : (row['year'] ?? '');
          row['type_chapter'] = row['id_section'] == 4  ? (row['chapter'] ?? '')  : ((row['id_content_subject'] ?? '') + ' ' + (row['type'] ?? '')+(row['content_answer'] != null? ' + Corrigé': ''));
          row["expanded"] = false;
          row["checked"] = false;
          row["id_content_duplicate"] = row["id_content_duplicate"] && !['raw', 'archived'].includes(row['state'])? row["id_content_duplicate"].split(',').map((el:any) => parseInt(el)).filter((el:any) => el !== row["id_content"]) :[];
          row['state_format'] = this.buildTagsHtml(row.state);
          row['active_format'] = this.buildTagsHtml(row.active.toString());
          return row;
        });
        
        this.showedRows = this.dataSource;
        this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;
        this.totalNavigations = Math.ceil(this.totalRows / this.filterData.limit);
        this.inProgress.emit(false);
      })
    }
  }

  computeMode(modes:any){
    let allStates:any = {
      1: 'raw',
      2: 'edited',
      3: 'classified',
      4: 'classified,edited',
      5: 'archived'
    }
    let states:any = []
    modes.forEach((i:any) => states.push(allStates[i]));
    return states;

  }
  setWaiting(value:any){
    this.inProgress.emit(value);
  }
  movePrevNextNavigation(action:string) {
    if (action == 'prev' && this.navIndex > 0) {
      this.navIndex--;
      this.loadData();
    }
    if (action == 'next' && this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.loadData();
    }
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
  selectAllOption(element: any){
    this.selectAll(element);
    this.cdRef.detectChanges();
  }
}
